import { logger } from '@/utils/logger';
import { env } from '@zopauk/nextjs-env';
import { staticTheme } from '@/utils/theme';
import React, { type PropsWithChildren } from 'react';
import { useServerExperiment } from '@zopauk/nextjs-amplitude-experiment/client';

export const MaintenanceGuard = ({ children }: PropsWithChildren<object>) => {
  const { error, data } = useServerExperiment('quopa_maintenance', {
    endpoint: `${staticTheme().basePath}/api/experiment`,
  });

  if (data && data?.['quopa_maintenance']?.key === 'on') {
    logger.debug({
      message: `Redirecting to maintenance page`,
      id: `[redirectToMaintenance]: Debug`,
    });
    window.location.assign(env('MAINTENANCE_PAGE_URL')!);
    return null;
  }

  if (error) {
    logger.error({
      message: `Error fetching maintenance flag: ${error.message}`,
      id: `[MaintenanceGuard]: Error`,
    });
  }

  return <>{children}</>;
};
